import { createFileRoute } from "@tanstack/react-router";
import { ContatoPage } from "@/components/pages/ContatoPage";
import { ROUTE_META } from "@/i18n/route-meta";

const SITE = "https://kentro.com.br";

export const Route = createFileRoute("/$locale/contato")({
  head: ({ params }) => {
    const loc = params.locale === "es" ? "es" : "en";
    const d = ROUTE_META[loc];
    const ogLocale = loc === "es" ? "es_ES" : "en_US";
    return {
      meta: [
        { title: d.contactPage.metaTitle },
        { name: "description", content: d.contactPage.metaDesc },
        { property: "og:title", content: d.contactPage.metaTitle },
        { property: "og:description", content: d.contactPage.metaDesc },
        { property: "og:url", content: `${SITE}/${loc}/contato` },
        { property: "og:locale", content: ogLocale },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/contato` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/contato` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/contato` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/contato` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/contato` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'Contato', item: `${SITE}/${loc}/contato` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'ContactPage',
            "@id": `${SITE}/${loc}/contato`,
            url: `${SITE}/${loc}/contato`,
            name: d.contactPage.metaTitle,
            description: d.contactPage.metaDesc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: ContatoPage,
});
